import type { ReactNode } from 'react';

export type BadgeTone = 'neutral' | 'training' | 'nutrition' | 'recovery' | 'attention' | 'danger';

const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-surface-muted text-ink-soft',
  training: 'bg-training-tint text-training',
  nutrition: 'bg-nutrition-tint text-nutrition',
  recovery: 'bg-recovery-tint text-recovery',
  attention: 'bg-attention-tint text-attention',
  danger: 'bg-danger-tint text-danger',
};

export interface BadgeProps {
  tone?: BadgeTone;
  children: ReactNode;
}

export function Badge({ tone = 'neutral', children }: BadgeProps) {
  return (
    <span
      className={[
        'inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium',
        TONES[tone],
      ].join(' ')}
    >
      {children}
    </span>
  );
}
